import React from 'react'
import PropTypes from 'prop-types';
import { spacing } from '../../lib/theme';
import { staticAssetsPrefix } from '../../lib/utils';

export default function EmptyState(props) {
    const { message, subMessage, imageName, imageHeight } = props;
    return (
        <div style={{width: '100%'}}>
            <div className='main' style={{}}>
                {/* <div className='empty-state no-data'></div> */}
                <img className='empty-state no-data' src={`${staticAssetsPrefix}/static/images/empty-state/${imageName}.svg`} />
                <h4>{message}</h4>
                {subMessage && <h5>{subMessage}</h5>}
            </div>
            <style jsx>
                {`
                    .main {
                        margin-bottom: ${spacing('lg')};
                        text-align: center;
                        text-align: -moz-center;
                        width: 100%; 
                        min-height: 25vh;
                    }
                    .empty-state {
                        height: ${imageHeight};
                        // width: 30vw;
                        background-size: 100% 100%;
                        background-position: center top;
                        background-repeat: no-repeat;
                        margin-bottom: ${spacing('sm')};
                      }
                      .no-data {
                          background-image: url(${staticAssetsPrefix}/static/images/empty-state/${imageName}.svg);
                      }
                `}
            </style>
        </div>
    )
}

EmptyState.defaultProps = {
    imageHeight: '30vh'
}

EmptyState.propTypes = {
    message: PropTypes.string,
    subMessage: PropTypes.string,
    imageName: PropTypes.string.isRequired,
    imageHeight: PropTypes.string
}